module.exports.__PREFIX__ = window.REACT_URL_PREFIX || '/';